exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-top-bar[data-v-1cd1501f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: 1px solid #d4d4d4;\n  border-bottom: 1px solid #d4d4d4;\n  overflow: hidden;\n  height: 55px;\n  cursor: pointer;\n}\n.pop-top-bar .img-icon[data-v-1cd1501f] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.pop-top-bar .img-icon[data-v-1cd1501f] .el-icon-picture {\n  width: 100%;\n  height: 100%;\n  line-height: 55px;\n  text-align: center;\n}\n", ""]);

// exports
